export interface IApplicationState {
    startTrail: boolean,
    trailStartPosition: any,
};

const initialState: IApplicationState = {
    startTrail: false,
    trailStartPosition: []
};

export enum actionTypes {
    START_TRAIL = '@@trail/START_TRAIL',
    END_TRAIL = '@@trail/END_TRAIL',
    SET_START_TRAIL_POSITION = '@@trail/SET_START_TRAIL_POSITION',
}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const { trailStartPosition } = action;

    switch (action.type) {
        case actionTypes.START_TRAIL:
            return {
                ...state, startTrail: true
            };
        case actionTypes.END_TRAIL:
            return {
                ...state, startTrail: false
            }
        case actionTypes.SET_START_TRAIL_POSITION:
            return {
                ...state, trailStartPosition: trailStartPosition
            };
        default:
            return state;
    }
}

export const actions = {
    startTrail: (): any => ({ type: actionTypes.START_TRAIL }),
    endTrail: (): any => ({ type: actionTypes.END_TRAIL }),
    setStartTrailPosition: (trailStartPosition: any): any => ({ type: actionTypes.SET_START_TRAIL_POSITION, trailStartPosition }),
};
